import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormModalShell from "../ui/form-modal-shell";
import { FormSelectRow } from "./form-select-row";
import {
  CourierActions,
  CourierCheck,
  CourierReadonly,
  CourierText
} from "../ui/courier-fields";

const EditZoneForm = ({
  zone,
  cities = [],
  closeModal,
  loading,
  apiError,
  updateCourierZone
}) => (
  <FormModalShell title="Edit Zone" apiError={apiError} onClose={closeModal}>
    <Formik
      enableReinitialize
      initialValues={{
        name: zone.name || "",
        city: zone.city || "",
        isActive: zone.isActive !== false
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required("Required field"),
        city: Yup.string().required("Required field")
      })}
      onSubmit={values => {
        updateCourierZone({
          id: zone.id,
          data: {
            name: values.name,
            city: Number(values.city),
            isActive: values.isActive
          }
        });
      }}
    >
      {formik => (
        <Form>
          <CourierReadonly label="Code" value={zone.code} />
          <CourierText label="Zone Name" name="name" />
          <FormSelectRow
            label="City"
            name="city"
            value={formik.values.city}
            onChange={e => formik.setFieldValue("city", e.target.value)}
            error={formik.touched.city && formik.errors.city}
            required
            placeholder="Select city"
            options={(Array.isArray(cities) ? cities : []).map(c => ({
              value: c.id,
              label: c.name
            }))}
          />
          <CourierCheck
            label="Active"
            checked={formik.values.isActive}
            onChange={e => formik.setFieldValue("isActive", e.target.checked)}
          />
          <CourierActions
            loading={loading}
            submitLabel="Save Changes"
            onCancel={closeModal}
          />
        </Form>
      )}
    </Formik>
  </FormModalShell>
);

export default EditZoneForm;
